import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

import { UiInputModule } from '@cigna/shared/angular/input-ui';
import { UiButtonModule } from '@cigna/shared/angular/button-ui';
import { UiIconModule } from '@cigna/shared/angular/icon-ui';
import { AnalyticsUiModule } from '@cigna/shared/angular/analytics-ui';
import {
  CignaLeafAlertComponent,
  CignaLeafFieldNoteComponent,
  CignaLeafHeadingComponent,
  CignaLeafLoadingSpinnerComponent,
} from '@cigna/shared/angular/leaf-ui';

import { ChcpSharedUiModule } from '@cigna/chcp/shared/ui';
import { ChcpRoutes } from '@cigna/chcp/shared/util';
import { ChcpShellUiModule } from '@cigna/chcp/shell/ui';
import { ChcpSharedEnvironmentUtilModule } from '@cigna/chcp/shared/environment-util';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { EvernorthProviderSharedUiModule } from '@cigna/evernorth-provider/shared/ui';
import { DialogWamFaqComponent } from './dialog-wam-faq/dialog-wam-faq.component';

import { PageComponent } from './page/page.component';
import { ResourceLinksComponent } from './resource-links/resource-links.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { LoginFormAuth0Component } from './login-form-auth0/login-form-auth0.component';
import { LoginMessageComponent } from './login-message/login-message.component';
import { DialogWhatIsTempIdComponent } from './dialog-what-is-temp-id/dialog-what-is-temp-id.component';
import { TranslateModule } from '@ngx-translate/core';
import { UiCollapsibleModule } from '@cigna/shared/angular/collapsible-ui';
import { LoginMessageV2Component } from './login-message-v2/login-message-v2.component';

const routes: ChcpRoutes = [
  {
    path: '',
    pathMatch: 'full',
    component: PageComponent,
    data: {
      title: 'Login',
      analytics: {
        name: 'Login',
        section: 'Login',
        prop13: 'pv22390',
        eVar119: 'US1876442',
        loggedIn: false,
      },
    },
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    UiInputModule,
    UiButtonModule,
    UiIconModule,
    EvernorthProviderSharedUiModule,
    MatDialogModule,
    ReactiveFormsModule,
    ChcpShellUiModule,
    ChcpSharedEnvironmentUtilModule,
    ChcpSharedUiModule,
    CignaLeafHeadingComponent,
    CignaLeafAlertComponent,
    CignaLeafFieldNoteComponent,
    CignaLeafLoadingSpinnerComponent,
    AnalyticsUiModule,
    TranslateModule,
    UiCollapsibleModule,
  ],
  declarations: [
    PageComponent,
    LoginFormComponent,
    LoginFormAuth0Component,
    LoginMessageV2Component,
    ResourceLinksComponent,
    DialogWhatIsTempIdComponent,
    LoginMessageComponent,
    DialogWamFaqComponent,
  ],
})
export class EvernorthProviderLoginShellFeatureModule {}
